<template>
  <div
    class="matrix_layoutMain matrix_layoutUseMatrix container matrix_layoutImageEditorContainer"
  >
    <div class="row">
      <div class="col-md-9 matrix_layoutMatrixContainerColMain">
        <div class="matrix_productPartsMainContainer matrix_table">
          <appImageEditor></appImageEditor>
        </div>
        <div
          class="matrix_productPartsMainContainer matrix_table matrix_table_gallery"
        >
          <appImageEditorGalleries></appImageEditorGalleries>
        </div>
        <div class="matrix_summaryInformation">
          <appSummaryTable></appSummaryTable>
          <appInformationTable></appInformationTable>
        </div>
      </div>
      <div class="col-md-3 matrix_layoutMatrixContainerColSidebar">
        <appOptionsTable>
          <appOptionsContainer showPopup="1"></appOptionsContainer>
          <appInputCustomFormatInsert></appInputCustomFormatInsert>
        </appOptionsTable>
        <appAddToCartButton
          class="matrix_addToCartButtonMain"
        ></appAddToCartButton>
        <appQuantityTable>
          <appQuantityContainer></appQuantityContainer>
          <appInputQuantity></appInputQuantity>
        </appQuantityTable>
        <appSteckdosen></appSteckdosen>
        <appCornersEditor></appCornersEditor>
        <appCutouts></appCutouts>
        <appOtherOptionsTable>
          <appOtherOptionsContainer></appOtherOptionsContainer>
        </appOtherOptionsTable>
        <appUploadTable alwaysShow="true"></appUploadTable>
      </div>
    </div>
    <appImageEditorInputs></appImageEditorInputs>
    <appCanvas></appCanvas>
  </div>
</template>
<script>
require("../../libs/oie/jquery-ui-1.11.4");
require("../../libs/oie/draggable_background");
require("../../libs/oie/jquery.ui.rotatable");
require("../../libs/oie/patch_draggable");
require("../../libs/oie/resizable-rotatable.patch");
require("../../libs/oie/jquery.pep");
require("../../libs/oie/cropper");
require("../../libs/oie/css/cropper.min.css");
require("../../libs/oie/jquery-cropper");
require("../../libs/oie/oie_helper");
import ImageEditor from "./imageEditor/ImageEditor";
import ImageEditorGalleries from "./imageEditorGalleries/ImageEditorGalleries";
import Steckdosen from "./imageEditor/Steckdosen";
import CornersEditor from "./imageEditor/CornersEditor";
import Cutouts from "./imageEditor/Cutouts";
import ImageEditorInputs from "./imageEditor/ImageEditorInputs";
import Canvas from "./imageEditor/Canvas";

import { useImageEditorStore } from "@/stores/modules/imageEditor";
import { mapState, mapActions } from "pinia";

export default {
  components: {
    appImageEditor: ImageEditor,
    appImageEditorGalleries: ImageEditorGalleries,
    appSteckdosen: Steckdosen,
    appCornersEditor: CornersEditor,
    appCutouts: Cutouts,
    appImageEditorInputs: ImageEditorInputs,
    appCanvas: Canvas
  },
  computed: {
    ...mapState(useImageEditorStore, ["getPOIEVariables"])
  },
  methods: {
    ...mapActions(useImageEditorStore, ["initEditor", "changeImageId"])
  },
  created: function () {
    this.$nextTick(
      (function (that) {
        return function () {
          var POIEVariables = that.getPOIEVariables;
          that.changeImageId(POIEVariables.defaults.imageId);
          that.initEditor({});
        };
      })(this)
    );
  }
};
</script>
